import { render, staticRenderFns } from "./BpcHeader.vue?vue&type=template&id=0df8dbce&"
import script from "./BpcHeader.vue?vue&type=script&lang=js&"
export * from "./BpcHeader.vue?vue&type=script&lang=js&"
import style0 from "./BpcHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports